import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth';
import broadcast from './modules/broadcast';
import flag from '@/store/modules/flag';
import notifications from './modules/notifications';
import user from './modules/user';
import order from './modules/order';
import cache from './modules/cache';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        auth,
        broadcast,
        flag,
        notifications,
        user,
        order,
        cache,
    },
    plugins: [createPersistedState({
        key: 'gxstate',
        reducer(val) {
            // not authenticated, clear state
            if (val.auth.token === null) {
                return {};
            }
            return val;
        }
    })],
    strict: debug,
});
